import { Component, Input } from '@angular/core';
import { Airport } from 'src/app/domain/models/Airport';
import { City } from 'src/app/domain/models/City';
import { Country } from 'src/app/domain/models/Country';
import { Port } from 'src/app/domain/models/Port';

@Component({
  selector: 'app-location-info',
  templateUrl: './location-info.component.html',
  styleUrls: ['./location-info.component.css']
})
export class LocationInfoComponent {

@Input()
countryCode: string | undefined;
@Input()
countryName: string | undefined;
@Input()
type!: number;
@Input()
cityName: string | undefined;
@Input()
portName: string | undefined;
@Input()
airportName: string | undefined;
@Input()
showLocationName: boolean = true;
@Input()
useFigureIcon: boolean = false;

}
